import { api } from "@/lib/api";
import { TipoIdentificacion } from "../Types/types";

export interface ResetPasswordPayload {
  email: string;
  num_id: string;
  tipo_id: string;
}

export interface ResetPasswordResponse {
  success: boolean;
  message?: string;
}

export const resetPasswordRequest = async (
  payload: ResetPasswordPayload
): Promise<ResetPasswordResponse> => {
  const { data } = await api.post<ResetPasswordResponse>(
    "/api/auth/resetPassword",
    payload
  );
  return data;
};

export const fetchTiposIdentificacion = async (): Promise<TipoIdentificacion[]> => {
  const { data } = await api.get(
    "/api/dashboards/mis_datos/selects/tipos_identificacion"
  );

  if (data && data.data && Array.isArray(data.data)) {
    return data.data;
  }

  if (data && Array.isArray(data)) {
    return data;
  }

  console.error("Formato de datos inesperado:", data);
  return [];
};

export const mapApiErrorToMessage = (
  status?: number,
  payload?: unknown
): string => {
  const str = payload ? String(payload).toLowerCase() : "";

  if (
    status === 404 ||
    str.includes("not found") ||
    str.includes("no encontrado")
  ) {
    return "No se encontró una cuenta con esos datos. Verifica la información ingresada.";
  }
  if (
    status === 422 ||
    str.includes("validation") ||
    str.includes("validación")
  ) {
    return "Los datos ingresados no son válidos. Por favor revísalos e intenta de nuevo.";
  }
  if (status && status >= 500) {
    return "Error en el servidor. Intenta más tarde.";
  }

  if (Array.isArray(payload)) {
    return payload.slice(0, 3).join(", ");
  }

  if (payload && typeof payload === "object" && payload !== null) {
    const errorObj = payload as Record<string, unknown>;

    if (errorObj.error && typeof errorObj.error === "string") {
      return errorObj.error;
    }
    if (errorObj.message && typeof errorObj.message === "string") {
      return errorObj.message;
    }
    if (Array.isArray(errorObj.errors) && errorObj.errors.length) {
      return errorObj.errors
        .slice(0, 2)
        .map((it) => String(it))
        .join(" - ");
    }
  }

  return "Error al enviar solicitud de recuperación. Verifica tus datos e intenta nuevamente.";
};
